import type { ReactNode } from 'react'
import { useAdminOrderEvents } from '@/modules/orders-api'
import { AdminSidebar } from './AdminSidebar'
import { AdminTopbar } from './AdminTopbar'

export function AdminShell({ children }: { children: ReactNode }) {
  // useAdminOrderEvents() // TODO: wire nginx /socket.io proxy
  return (
    <div className="min-h-screen bg-slate-50 flex">
      <AdminSidebar />
      <div className="flex-1 min-w-0 flex flex-col">
        <AdminTopbar />
        <main className="flex-1 p-6">{children}</main>
      </div>
    </div>
  )
}
